// extracted by mini-css-extract-plugin
export default {"root":"eE6Tc1jS","heading":"t2c1u8kn","buttonsContainer":"F5GfKszI","button":"_332hQ89W"};